import { useNavigate } from '@tanstack/react-router';
import { useLayoutEffect, useRef } from 'react';

type Navigate = ReturnType<typeof useNavigate>;

/**
 * 마운트마다 **한 번만** 이동한다. 가드·옛 주소 이동은 TanStack `<Navigate>` 대신 이것을 쓴다.
 *
 * ★ `<Navigate>` 는 props 객체가 바뀔 때마다 다시 이동한다. 위치를 구독하는 레이아웃 안에 두면 이동 → 위치 갱신 →
 *   다시 그림(새 props 객체) → 다시 이동이 **동기로** 돌아 탭이 멎는다(실측 260917: `/` → `/app` → `/login` 에서
 *   메인 스레드가 AppLayout 렌더 루프에 갇혔다). 옛 RootLayout 은 도착한 화면에서 `<Navigate>` 를 그리지 않아 드러나지 않았다.
 *
 * 같은 자리에서 다른 곳으로 보내는 분기가 바뀔 수 있으면 `key` 를 달아 새로 마운트한다 — 인스턴스가 재사용되면 두 번째
 * 이동이 일어나지 않는다. `go` 는 호출부에서 타입 검사를 받도록 navigate 를 넘겨받는다.
 */
export function Redirect({ go }: { go: (navigate: Navigate) => unknown }) {
  const navigate = useNavigate();
  const done = useRef(false);
  useLayoutEffect(() => {
    if (done.current) return;
    done.current = true;
    void go(navigate);
  });
  return null;
}
